export default {
    DataItemName: '控件名称',
    Visible: '是否可见',
    ControlStyle: '控件样式',
    ControlTips: '控件Tips',
    LabelVisible: '标题显示',
    ControlType: '控件类型',
    MultiLanguage: '多语言',
    DataItemCode: '绑定数据项编码',
    DataItemType: '数据项类型',
    DataDictionary: '数据字典',
    DisplayConditions: '显示条件',
    ChangeEvent: '变更事件',
    RequiredFormula: '是否必填',
    ReadonlyConditions: '只读条件',
    ReadonlyFormula: '是否只读',
    DefaultValue: '默认值',
    Regex: '正则校验',
    RegexErrTips: '正则错误提示',
    Placeholder: '提示文字',
    InputPlaceholder: '请输入',
    MaxLength: '最大长度',
    DeDuplicateVerification: '去重校验',
    DataLinkage: '数据联动',
    CalculationRules: '计算规则',
    InputByScanCode: '扫码输入',
    InputBoxStyle: '输入框样式',
    WordLimit: '字数限制',
    DefaultValue2: '数据项默认值',
    Format1: '显示格式',
    SyncDefaultFormat: '同步默认格式',
    Format: '默认格式',
    Minimum: '最小值',
    Maximum: '最大值',
    SubmitValidation: '提交校验规则',
    WebDirection: 'web端方向',
    DisplaySetting: '显示设置',
    Options: '选项',
    ShowEmptyOptions: '是否显示空选项',
    EmptyOptionsValue: '空选项显示值',
    SelectPlaceholder: '请选择',
    Multi: '是否多选',
    FileTypeLimit: '限定文件类型',
    FileTypeLimitTips: '设置附件上传的文件名格式，限定类型为office、图片、压缩包等，示例:.jpg,.gif.<br>以下类型不支持:<br>.php.php5.php4.php3.php2.php1&nbsp;.html.htm.phtml.pHp.pHp5.pHp4.pHp3.pHp2.pHp1&nbsp;.Html.Htm.pHtml.jsp.jspa.jspx.jsw.jsv.jspf.jtml.jSp&nbsp;.jSpx.jSpa.jSw.jSv.jSpf.jHtml.asp.aspx.asa.asax&nbsp;.ascx.ashx.asmx.cer.aSp.aSpx.aSa.aSax.aScx.aShx.aSmx.cEr.sWf.swf',
    AttachmentTemplate: '附件模板',
    UploadTemplate: '上传模板',
    FileSizeLimit: '文件大小限制',
    BatchDownload: '批量下载',
    UploadEvent: '上传事件',
    DeleteEvent: '删除事件',
    UploadQuantity: '上传数量',
    Watermark: '水印',
    WatermarkFontSize: '水印字体大小',
    ImageQuality: '图片质量',
    Compress: '压缩',
    OnlyPhoto: '只允许拍照',
    DisplayTerminal: '显示端',
    Mobile: '移动端',
    PreciseRange: '精确范围',
    DisplayType: '显示模式',
    AutoLocation: '自动获取位置',
    LocationSearch: '定位搜索',
    AddressFormat: '地址格式',
    AddressDetail: '显示详细地址',
    DisplayEmpty: '显示空选项',
    EmptyValue: '空值',
    OptionalType: '可选类型',
    OrgRootNode: '组织根节点',
    RecursivelyDisplay: '是否递归展示',
    RoleScope: '角色范围',
    Mapping: '映射关系',
    DefaultExpand: '默认展开',
    Align: '对齐',
    DataLimit: '数据限定范围',
    BizModal: '选择业务模型',
    DisplayStyle: '显示样式',
    QueryList: '查询列表',
    DisplayField: '显示字段',
    MappingField: '映射字段',
    QueryConditions: '查询条件',
    MobileQueryConditions: 'mobile查询条件',
    LinkMode: '显示链接模式',
    SelectType: '选择方式',
    ModelField: '弹出框字段',
    TemporaryAuthorization: '临时授权',
    BizModal2: '业务模型',
    RelevanceField: '关联字段',
    DisplayType2: '展示方式',
    RelevanceFieldType: '关联字段类型',
    SerialCode: '流水号编码',
    ResetTime: '重置策略时间',
    Connector: '连接符',
    ColumnWidth: '列宽px',
    DefaultRows: '默认行数',
    Editable: '是否编辑',
    EmptyLine: '空行校验',
    Importable: '是否导入',
    Emportable: '是否能导出',
    ImportFromRelevanceForm: '从关联表单导入',
    DisplaySummaryRows: '是否显示汇总行',
    BatchEditable: '是否批量编辑',
    SheetQueryCondition: '子表筛选条件',
    AddRowEvent: '行新增事件',
    DeleteRowEvent: '行删除事件',
    MobileStyle: '移动端样式',
    SummaryMode: '统计模式',
    DefaultOptions: '默认选项',
    DefaultValueType: '默认值类型',
    RadioDefaultOptions: '选项1;选项2;选项3',
    Location: '地图定位',
    Address: '地址',
    ProvinceCityCounty: '省/市/县区',
    ProvinceCity: '省/市',
    Province: '省',
    Set: '已设置',
    Unset: '未设置',
    Yes: '是',
    No: '否',
    RequiredWithConditions: '满足条件必填',
    Attachment: '附件',
    Image: '图片',
    Signature: '手写签名',
    ValidityErrTips: '长度不能超过{num}字节',
    ClickOrDragUpload: '点击或拖拽上传',
    TemplateDownload: '附件模板下载',
    Horizontal: '横向',
    Portrait: '纵向',
    TickOption: '勾选项',
    AllItems: '全部项',
    Format1Tips: '文字为绿色的时候，表示和默认格式同步',
    Null: '空',
    CurrentTime: '当前时间',
    Multi2: '多选',
    Organization: '组织',
    CreateBy: '创建人',
    CreateByDept: '创建人部门',
    Single: '单选',
    Left: '左',
    Middle: '中',
    Right: '右',
    Small: '小',
    Big: '大',
    Large: '特大',
    Accurate: '准确定位',
    Arbitrary: '任意位置',
    ValidityErrTips2: '只能输入正整数',
    ValidityErrTips3: '最大长度不能超过{num}',
    ValidityErrTips4: '字数限制不能为空',
    ValidityErrTips5: '最大字数不能超过',
    Textarea: '多行文本',
    Richtext: '富文本',
    ValidityErrTips6: '只能输入数值类型，最大长度19位数，精度3位数',
    DataTitle: '数据标题',
    List: '平铺',
    Tree: '树形',
    PopupModal: '弹出框',
    DropdownInput: '下拉框',
    PopupField: '弹出框字段',
    Readable: '可读',
    Selectable: '可选',
    RelevanceForm: '关联单选',
    RelevanceFormMulti: '关联多选',
    List2: '列表',
    Linking: '链接',
    Tabs: '页签形式',
    DetailList: '详情列表',
    NotReset: '不重置',
    Daily: '每天',
    Monthly: '每月',
    Yearly: '每年',
    ValidityErrTips7: '控件名称不能为空',
    ValidityErrTips8: '长度不能超过50',
    ValidityErrTips9: '不能以空格开始',
    ValidityErrTips10: '列宽不能为空',
    ValidityErrTips11: '不能超过最大宽度885',
    ValidityErrTips12: '不能小于最小宽度150',
    ValidityErrTips13: '默认行数不能为空',
    ValidityErrTips14: '默认行数不能超过100',
    WaterFall: '瀑布样式',
    TwoDimensional: '二维表',
    Pageing: '分页样式',
    NotCounted: '不统计',
    Summation: '求和',
    AverageValue: '平均值',
    User: '用户',
    All: '全部',
    SystemAutoFill: '系统自动填充',
    CheckType: '检查类型',
    RequiredType: '必填方式',
    NotRequired: '非必填',
    DisplayDataItem: '显示数据项',
    CheckDataItem: '校验数据项',
    LinkageTargetModel: '联动目标模型',
    LinkageTargetForm: '联动目标表单',
    LinkageCondition: '联动条件',
    CurrentModelDataItem: '当前模型数据项',
    LinkedModelDataItem: '联动模型数据项',
    ValueEqual: '值等于',
    AddCondition: '新增条件',
    LinkedFill: '联动填充',
    CancelLink: '取消联动',
    NoLinkageModel: '请选择联动模型',
    NoLinkFill: '联动填充项不能为空',
    LinkModelNotSame: '联动填充项模型不相同',
    NoCondition: '条件配置项不能为空',
    CancelLinkTips: '取消联动会清空当前设置的联动数据，确定要取消该数据联动吗？',
    UploadTemplateTips: '你已上传',
    UploadTemplateTips2: '个模板，',
    UploadTemplateTips3: '附件模版上传数量不能超过10个',
    UploadFileTemplate: '上传附件模板',
    ViewTemplate: '查看模板',
    UploadFileTemplateTips: '{file}文件最大可上传{num}B',
    UploadFileTemplateTips2: '文件格式不对，仅支持上传文档格式的文件！',
    UploadFileTemplateTips3: '最大不能超过10M！',
    UploadFileTemplateTips4: '最多允许上传10个模板文件',
    EventTips: 'value 当前值，oldValue旧值，form表单对象',
    EventPlaceholder: '请输入{title}详细信息，例：form.text1.value = \'\'',
    OptionsSource: '选项来源',
    SortDataItems: '排序数据项',
    SortRule: '排序规则',
    Ascending: '升序 A-Z',
    Descending: '降序 Z-A',
    Default: '默认',
    QueryDataItem: '查询数据项',
    ValueType: '值类型',
    OptionsSetting: '选项设置',
    BizDataItemOptionsRules: '业务数据选项设置规范',
    BizDataItemOptionsSettingRule1: '表单设计时选项值最多勾选200个，且表单运行时单选框和复选框最多只展示200个选项。',
    BizDataItemOptionsSettingRule2: '相同的选项值会被过滤，仅留一个选项值。比如「姓名」字段，张三、张三、李四，选项值为张三、李四。重复的值会被过滤掉。',
    SelectedDataItems: '当前数据项',
    SelectedDataItems2: '条，您已选择',
    SelectedDataItems3: '条',
    SelectedDataItems4: '，还可以选择',
    SearchByNamePlaceholder: '请输入名称搜索',
    DynamicValue: '动态值',
    FixedValue: '固定值',
    OptionsTips: '最多选择200条数据',
    OptionsTips2: '自定义选项不能为空！',
    OptionsTips3: '业务模型不能为空',
    OptionsTips4: '数据项不能为空',
    OptionsTips5: '未选择选项值',
    OptionsTips6: '不能空格开头！',
    BatchSetOptions: '批量设置选项',
    SelectDictionary: '选择字典',
    DictionaryData: '字典数据',
    OptionsTips7: '未设置时，前台使用全部字典数据',
    LoadingData: '数据加载中...',
    DictionaryTips: '选择的字典没有数据项，请更换字典！',
    OptionalData: '可选数据',
    UnMatched: '没有匹配到相关信息',
    QueryRes: '符合查询条件的记录{num1}条，返回{num2}条',
    Total: '总数{num}条',
    OptionsTips8: '最多只能选择200个字典数据',
    OptionsTips9: '数据字典不能为空',
    InvalidMapping: '映射不合法',
    SetFormat1: '显示格式设置',
    SyncTips: '即与数据模型{model}默认格式保持一致',
    CheckType2: '校验类型',
    SubmitCheck: '提交校验',
    RegularCheckRules: '正则校验规则',
    IvalidRegex: '输入正则不合法',
    NoRulesErr: '请填写规则',
    CheckMethod: '校验方式',
    Constant: '常量',
    CheckRules: '校验规则',
    CheckRulesTips: '只能选择相同显示格式数据项；',
    CheckRulesTips2: '当选择当天时，输入框填写负数表示当天之前，零表示当天，正数表示当天之后，单位为天。',
    CheckRulesPlaceholder: '请选择数据项',
    CheckRulesPlaceholder2: '请输入数字',
    FailedMsg: '校验失败提示语',
    TipsPopup: '提示弹框',
    TipsPopupTips: '校验失败提示语字数较多时请使用长提示弹框，只针对web端',
    ShortTips: '短提示弹框',
    LongTips: '长提示弹框',
    TipsContent: '这是一条异常消息，会主动消失',
    ErrorTips: '错误提示',
    ErrorTipsTips: '一系列的信息描述，可能会很长。也可以是很短同样也可以带标点。',
    TheDay: '当天',
    CheckRulesPlaceholder3: '请选择日期范围',
    CheckRulesErrTips: '校验规则不合法！',
    CheckRulesErrTips2: '请输入右侧边界值！',
    CheckRulesErrTips3: '请输入左侧边界值！',
    CheckRulesErrTips4: '校验规则，左侧边界值不合法！',
    CheckRulesErrTips5: '校验规则，右侧边界值不合法！',
    CheckRulesErrTips6: '请选择右侧边界值！',
    CheckRulesErrTips7: '请选择左侧边界值！',
    SelectOrg: '选择组织架构',
    FormField: '表单字段',
    CreaterRelated: '创建人相关',
    SelectPlaceholder2: '点击选择',
    Single2: '单张',
    Multiple: '多张',
    Minimum2: '最小数量',
    Maximum2: '最大数量',
    InvalidMinimum: '最小值不合法！',
    InvalidMaximum: '最大值不合法！',
    MaximunMinimunErr: '最大值必须大于最小值！',
    AddressSettng: '设置地址',
    LocationSetting: '设置定位',
    CalcularDataItem: '计算数据项',
    Function: '函数',
    InsertDataItem: '插入数据项',
    SearchDataItem: '搜索数据项',
    SearchFunction: '搜索函数',
    CheckEx: '检验公式',
    Use: '用法',
    Example: '示例',
    ClearRule: '清空规则',
    FunctionErr: 'TODAY函数只能赋值给文本，不能赋值给数值',
    ClearRuleTips: '清空规则会清空当前设置的计算规则数据，确定要清空规则吗？',
    ExPlaceholder: '请选择或输入数据项、函数',
    Operator: '操作符',
    Canceled: '已取消',
    InputPlaceholder2: '日期格式2019-05-10 12:00:00',
    InputPlaceholder3: '时间格式12:00:00',
    InputPlaceholder4: '请输入，多个值以“;”连接',
    DataLimitTips: '请检查是否配置了业务模型',
    NoSheet: '当前模型或关联模型没有子表，不能映射',
    RelevanceModelErr: '关联模型不可用，请重新选择',
    NoBizModel: '当前表单未指定业务模型',
    RelevanceModelField: '关联模型字段',
    DefaultOperator: '默认操作符',
    Value: '值或当前表单字段',
    IsNull: '为空',
    NotNull: '不为空',
    Variable: '变量',
    InputPlacholder5: '日期格式: 2019-05-10',
    QueryConditionTips: '在子表中的关联多选控件不支持映射功能',
    QueryConditionTips2: '请检测当前表单是否已发布，或绑定的列表',
    QueryConditionTips3: '展示字段是否有同类型数据项！',
    QueryConditionTips4: '是否设置了查询条件！',
    AddField: '新增字段',
    CurrentFormField: '当前表单字段',
    TabSetting: 'Tab设置',
    AddTab: '新增Tab',
    TabConditionSetting: 'Tab条件设置',
    TabErrTips: 'Tab名称不能包含：双引号和单引号',
    Equal: '等于',
    NotEqual: '不等于',
    Above: '大于',
    Below: '小于',
    NotBelow: '大于等于',
    NotAbove: '小于等于',
    Contains: '包含',
    NotContains: '不包含',
    In: '位于',
    NotIn: '不位于',
    Of: '属于',
    NotOf: '不属于',
    Have: '拥有',
    NotHave: '不拥有',
    ShortText: '单行文本',
    Checkbox: '复选框',
    StaffSelector: '人员单选',
    DepartmentSelector: '部门单选',
    CreatedTime: '创建时间',
    Date: '日期',
    DepartmentMultiSelector: '部门多选',
    Description: '描述',
    Dropdown: '下拉单选框',
    DropdownMulti: '下拉多选框',
    Logic: '逻辑',
    LongText: '长文本',
    ModifiedTime: '修改时间',
    Modifier: '修改人',
    Number: '数值',
    Owner: '拥有者',
    Radio: '单选框',
    ReverseRelevance: '关联查询',
    SequenceNo: '单据号',
    ShortText2: '短文本',
    Sheet: '子表',
    SheetStatistic: '子表统计',
    StaffMultiSelector: '人员多选',
    StaffSelectorMixed: '混合控件',
    Time: '时间',
    Summary: '统计',
    True: '是',
    False: '否',
};
